<template>
  <div class="form-group">
    <label :for="field.type + '_' + field.id" v-html="title"></label>
    <textarea
      :id="field.type + '_' + field.id"
      v-model="field.value"
      class="form-control popup"
      :placeholder="field.title"
    >
    </textarea>
  </div>
</template>
<script>
export default {
  name: "TextareaField",
  props: ["field"],
  computed: {
    title() {
      if (!this.field.isRequired) return this.field.title;
      return this.field.title + " " + '<span class="required">*</span>';
    },
  },
  created() {
    this.$set(this.field, "value", "");
  },
};
</script>
<style scoped>
textarea.popup.form-control {
  height: auto;
}
</style>
